import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';

const SwitchButtonField = ({ input, meta, inputProps }, error) => {
  const Component = inputProps.component || Button;

  return (
    <Component {...inputProps}
      color="info"
      className={classnames(inputProps.className, {
        'is-invalid': error && !meta.dirty
      })}
      onClick={() => input.onChange(input.value ? !input.value : true)}
    >{inputProps.title}</Component>
  );
};

SwitchButtonField.propTypes = {
  input: PropTypes.propTypes,
  inputProps: PropTypes.object,
  meta: PropTypes.object,
};

export default SwitchButtonField;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/SwitchButtonField.jsx